import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenubarService {
  private _showMenubar: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public showMenubar$ = this._showMenubar.asObservable();

  public get showMenubar(): boolean {
    return this._showMenubar.value;
  }

  public set showMenubar(value: boolean) {
    this._showMenubar.next(value);
  }
}
